var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCallingIcon = function SvgCallingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M22.46 8.235a1.28 1.28 0 0 0-1.505 1.02 1.294 1.294 0 0 0 1.015 1.515 5.19 5.19 0 0 1 4.116 4.125 1.29 1.29 0 0 0 1.509 1.022A1.297 1.297 0 0 0 28.61 14.4a7.76 7.76 0 0 0-6.15-6.165"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M22.367 3.012a1.23 1.23 0 0 0-.938.264 1.28 1.28 0 0 0-.484.877 1.29 1.29 0 0 0 1.135 1.424c4.863.542 8.642 4.33 9.189 9.208a1.286 1.286 0 1 0 2.556-.288c-.682-6.086-5.392-10.81-11.458-11.485"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    fillRule: "evenodd",
    d: "M17.38 19.459c5.984 5.982 7.342-.939 11.152 2.868 3.672 3.672 5.783 4.408 1.13 9.06-.583.468-4.287 6.104-17.302-6.907C-.657 11.466 4.975 7.759 5.444 7.176c4.665-4.665 5.388-2.542 9.06 1.13 3.81 3.809-3.107 5.17 2.877 11.153",
    clipRule: "evenodd"
  })));
};
export default SvgCallingIcon;